import { useEffect } from 'react'

/**
 * Bestimmt, wie die Datei heißt, wenn der Browser die Seite als PDF speichert.
 *
 * Es gibt dafür keine API. Chrome, Safari und Firefox nehmen alle den Titel des
 * Dokuments und hängen `.pdf` an — das ist der einzige Hebel, den eine Web-App hat,
 * und deshalb steht hier ein `document.title` und keine Download-Option.
 *
 * Der vorherige Titel wird beim Verlassen zurückgesetzt: der Titel steht im
 * Browsertab und in der Verlaufsliste, und „Rechnung_R-2026-0002" darf dort nicht
 * kleben bleiben, nachdem der Vermieter längst wieder im Kalender ist.
 */
export function usePrintFileName(name: string | null) {
  useEffect(() => {
    if (!name) return
    const previous = document.title
    document.title = name
    return () => { document.title = previous }
  }, [name])
}
